import { getPhotosForPhotowall } from 'entities/photos';

Pixlee.module('PhotowallApp.Show', function(Show, App, Backbone, Marionette, $) {
    Show.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var collectionView, headerView;
            var photoscollection = getPhotosForPhotowall();
            var layout = new Show.Layout({ collection: photoscollection });
            var _this = this;
            this.listenTo(layout, 'show', function() {
                collectionView = new Show.PhotowallCollection({
                    collection: photoscollection,
                    displayOptions: options.display_options
                });
                photoscollection.on('sync', function(collection, resp) {
                    if (_this.widgetloaded) {
                        return false;
                    }
                    _this.widgetloaded = true;
                    gon.sortType = resp.sortType;
                    App.commands.execute('opened:photowall', collection.pluck('album_photo_id'));
                });
                var headerLayout = _.isFalsy(options.display_options.headerOptions) ? '' : options.display_options.headerOptions.layout;
                headerView = new Show.HeaderView({ model: App.currentAlbum });
                this.show(headerView, {
                    region: layout.widget_header_region
                });
                this.show(collectionView, {
                    region: layout.frame
                });
                if (!_.isFalsy(options.display_options.is_interactive)) {
                    var navbarView = this.getNavbarView(options, photoscollection);
                    this.show(navbarView, {
                        region: layout.interactive_region
                    });
                }
            });
            if (!_.isFalsy(gon.previewMode)) {
                var widget_numberOfPhotos = '30';
                var header_sponserImage_input;

                App.commands.setHandler('stylesheet:generated', function(css, params,display_options) {
                    widget_numberOfPhotos = widget_numberOfPhotos || display_options.pageSize;
                    header_sponserImage_input = header_sponserImage_input || params.header_sponserImage_input;
                    if (!_.isFalsy(params.header_sponserImage_input)) {
                        header_sponserImage_input = params.header_sponserImage_input;
                        App.displayOptions.set('header_sponserImage_input', header_sponserImage_input);
                        var headerLayout = _.isFalsy(options.display_options.headerOptions) ? '' : options.display_options.headerOptions.layout;

                        headerView = new Show.HeaderView({ model: App.currentAlbum });
                        _this.show(headerView, {
                            region: layout.widget_header_region
                        });
                    }
                    collectionView.triggerMethod('stylesheet:generated');
                });
            }

            this.show(layout, {
                loading: true
            });

        },
        getNavbarView: function(options, photoscollection) {
            return App.request('get:navbar:view', options, photoscollection);
        }
    });

});
